export default __webpack_public_path__ + "static/media/Tasset of the Victorious Elite.339307f6.jpg";